module.exports = __webpack_public_path__ + "img/logo.a6fd3359.svg";